<app-header></app-header>

<div oncontextmenu="return false;">
<app-slider></app-slider>
<app-main-features></app-main-features>
<app-services></app-services>
</div>
